'use strict';

$.extend($.fn.dataTable.defaults, {
    "serverSide": true,
    "iCookieDuration": 60,
    "paging": true,
    "processing": true,
    "responsive": true,
    "destroy": true,
    "retrieve": true,
    "lengthChange": true,
    "language": {
        "emptyTable": "There are no records to display."
    },
    searching: false,
    "ajax": {
        // any additional data to send
        "data": function (additionalData) {
            additionalData.page = (additionalData.start / additionalData.length) + 1;
        }
    }
});

/**
    * Initilize DataTable
    *
    * @param tableID {string} - table id
    * @param dtOptions {object} - datatable options
    * @param dsOptions {object} - datastore options
    *     
    * @return datatable instance
    *-------------------------------------------------------- */

function dataTable(tableID, dtOptions, dsOptions, callbackFunction) {
	
    if (callbackFunction) {
        dtOptions.callbackFunction = callbackFunction;
    }
    
    return $(tableID).DataTable(dtConfig(dtOptions, dsOptions));

};

/**
    * DataTable Custom Configuration generation based on provided data
    *
    * @param object {options} - Object  
    *                         url          (required)
    *                         scope        (required)
    *                         columnsData  (required)
    *                         dtOptions    (optional)
    *     
    * @return array
    *-------------------------------------------------------- */

function dtConfig(options, dsOptions) {

    var dataStoreInstance = this;

    if (!dsOptions || !_.isObject(dsOptions)) {

        dsOptions = {};

    }
	
    var dtOptionsCollection = {
		
        "ajax": function (data, callback, settings) {
			
            // for laravel 5 paginate
            data.page = (data.start / data.length) + 1;

            var drawID = data.draw ? data.draw : false,
                optionsSendToFetch = {
                    params: data,
                    fresh: dsOptions.fresh ? dsOptions.fresh : false
                };

            if (_.has(dsOptions, 'persist')) {
                optionsSendToFetch['persist'] = dsOptions.persist;
            }
			
            var urlID = options.url,
                requestURL = '';
            if (optionsSendToFetch.params) {

                requestURL = urlID + '?' + $.param(optionsSendToFetch.params);
				
                if (_.has(optionsSendToFetch.params, 'draw')) {

                    delete optionsSendToFetch.params['draw'];

                }

                urlID = urlID + '?' + $.param(optionsSendToFetch.params);

            }
            // Send Ajax request for get datatable data
            __DataRequest.get(requestURL, {}, function (response) {
                response.draw = drawID;

                // callback for datatable after data fetched
                if (options.callbackFunction && _.isFunction(options.callbackFunction)) {
                    options.callbackFunction.call(this, response);
                }

                callback(response);
            });
        },
        "drawCallback": function (settings) {
            var api = this.api(),
                $thisDataTable = api.table();
            if (_.has($thisDataTable.columns, 'adjust') && _.has($thisDataTable.responsive, 'recalc')) {
                // responsive fix for datatable for cached datastore item 
                _.delay(function () {
                    $thisDataTable.columns.adjust().responsive.recalc()
                }, 180);
            }
        },
        "columns": [],
        /* "createdRow": function (nRow, data, dataIndex, cells) {
            $('td', nRow).eq(5).append('highlight');
        }, */
        // added on 19 MAY 2016 - 0.4.0
        "responsive": {
            "details": {
                "renderer": function (api, rowIdx, columns) {
                    var data = _.map(columns, function (col, i) {
                        return col.hidden ?
                            '<li data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                            '<span class="dtr-title">' +
                            col.title +
                            '</span> ' +
                            '<span class="dtr-data">' +
                            col.data +
                            '</span>' +
                            '</li>' :
                            '';
                    }).join('');
                    return data;
                    //return data ? $('<ul data-dtr-index="' + rowIdx + '"/>').append(data) : false;
                }
            }
        }
    };

    if (options.dtOptions) {

        _.assign(dtOptionsCollection, options.dtOptions);

    }

    dtOptionsCollection.columns = _.map(options.columnsData, function (dtColumnData) {

        return {

            "data": dtColumnData.name ? dtColumnData.name : null,
            "orderable": dtColumnData.orderable ? true : false,
            "render": function (subject, data, obj, settings) {

                if (!dtColumnData.name) {

                    obj = subject;

                } else {

                    obj.dtSubject = dtColumnData.name;

                }
                // if template given
                if (dtColumnData.template) {
                    
                    // compile data using underscore template
                    return __Utils.template(dtColumnData.template, obj);

                } else {

                    return obj[dtColumnData.name];
                }

            }

        };

    });

    return dtOptionsCollection;

};

	/**
    * Ajax Reload DataTable
    *
    * @param dataTableInstance {object} - datatable instance
    *     
    * @return datatable instance
    *-------------------------------------------------------- */

	function reloadDT(dataTableInstance) {

		dataTableInstance.ajax.reload(null, false);

		__Utils.log("__DataStore:: DataTable reloaded");

	};